import { get, post } from '../http/httpType';
import { carManagementApiUrl, organizationApiUrl, commonApiUrl } from "./index";
export default {
    /**文件上传 无业务id**/
    uploadFile: post('/cscec-common-business/files/upload', null, {
        useApi: 'api',
        stringify: false,
        headers: {
            'encType': 'multipart/form-data'
        }
    }),
    /**文件删除 无业务id**/
    deleteFile: post('/cscec-common-business/files', null, {
        useApi: 'api',
        stringify: false,
    }),
    projectId: get('/cscec-project-business/projects'),
    /**
     * 版本更新
     */
    uploadVision: get(carManagementApiUrl + '/appVersion/queryAppVersion'),
    /**
    * 登录人信息校验
    */
    loginLog: post(organizationApiUrl + '/log/loginLog'),
    /**
     * 新增签字信息
     */
    addSignInfo: (e) => {
        return post(commonApiUrl + '/signature' + e.params)(e.data)
    },
    /**
     * 编辑签字信息
     */
    updateSignInfo: (e) => {
        return post(commonApiUrl + '/signature/update' + e.params)(e.data)
    },
    /**
     * 删除签字信息
     */
    deleteSignInfo: post(commonApiUrl + '/signature/by-id'),
    /**
     * 根据用户Id获取签字信息
     */
    getSignInfoByUser: get(commonApiUrl + '/signature/by-user'),

}